module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"WidgetEditorComponentPalette":{"title":"Компоненты"}},"en_us":{"WidgetEditorComponentPalette":{"title":"Components"}}}')
  delete Component.options._Ctor
}
